module.exports = __webpack_public_path__ + "img/Active.6e785824.svg";